<template src="./user-profile.html">
</template>
<script>
  import Vue from 'vue'
  import { getPermissionClaims, hasRegistrationEditClaim, hasAdminClaim } from '@/router/auth'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import Vuelidate from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  import { validationMixin } from '@/mixins/validation'

  Vue.use(Vuelidate)

  export default {
    name: 'user-profile',
    mixins: [validationMixin],
    components: {
      Loader,
      ContextHeader
    },
    data () {
      return {
        load: false,
        hasAdminClaim: hasAdminClaim(),
        usedTocauseFatal: {},
        password: {
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: ''
        },
        personal: {
          language: {
            value: this.$store.getters.language,
            options: Vue.$config.user_settings.language_options
          },
          dateLocale: {
            value: this.$store.getters.dateLocale,
            options: Vue.$config.user_settings.date_locale_options
          },
          dateFormat: {
            value: this.$store.getters.dateFormat,
            options: Vue.$config.user_settings.date_format_options
          },
          decimalFormat: {
            value: this.$store.getters.decimalFormat,
            options: Vue.$config.user_settings.decimal_format_options
          },
          csvDelimmeter: {
            value: this.$store.getters.csvDelimmeter,
            options: Vue.$config.user_settings.CSV_separator_options
          }
        },
        register: {
          name: '',
          address: '',
          phoneNumber: '',
          email: '',
          treasuryBranch: '',
          adminName: '',
          adminIdentityNumber: '',
          adminEmail: '',
          adminPhoneNumber: ''
        },
        user: {},
        permissionClaims: [],
        canEditRegistration: false
      }
    },
    created: function (e) {
      this.canEditRegistration = hasRegistrationEditClaim()

      let claims = getPermissionClaims()
      if (claims.constructor === Array) {
        this.permissionClaims = getPermissionClaims()
      } else {
        this.permissionClaims.push(claims)
      }

      this.$http.get(Vue.$apiConfig.userInformationGet)
        .then(response => {
          this.logConsole(response)
          // get body data
          this.user = response.data.payload
        }, error => {
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    computed: {
      hasValidPasswords () {
        return this.password.oldPassword.length === 0 || this.password.newPassword.length === 0 || this.password.confirmNewPassword.length === 0
      }
    },
    methods: {
      causeFatal () {
        this.usedTocauseFatal.nonExistant()
      },
      changeUserPassword: function () {
        if (this.password.newPassword === this.password.confirmNewPassword) {
          this.user.password = this.password.oldPassword
          this.user.newPassword = this.password.newPassword
          this.load = true
          this.$http.post(Vue.$apiConfig.userPasswordChangePost, this.user)
            .then(response => {
              this.logConsole(response)
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('userAdministration.passwordChanged'),
                errors: []
              })
              this.load = false
            }, error => {
              this.logConsole(error)
              this.formatErrorResponse(error)
              this.load = false
            })
          this.$refs.changePasswordForm.reset()
          this.password.password = this.password.newPassword = this.password.confirmNewPassword = ''
        } else {
          this.logConsole('Confirm-old not valid')
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('userAdministration.confirmPasswordFail'),
            errors: []
          })
        }
      },
      validateRegistrationInformation () {
        this.$v.$touch()
        let registerValidationErrors = this.getValidationErrors('register')
        if (registerValidationErrors && registerValidationErrors.length > 0) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('register')
          })

          this.$nextTick(function () {
            document.body.scrollTop = 0
          })
          return
        }
        this.editRegistrationInformation()
      },
      editRegistrationInformation () {
        this.load = true
        this.logConsole(this.register)
        window.scrollTo(0, 0)

        let tempRegistration = JSON.parse(JSON.stringify(this.register))
        Vue.delete(tempRegistration, 'invoiceLimit')
        tempRegistration.treasuryBranch = this.register.treasuryBranch.toString()
        console.log(tempRegistration)
        this.$http.post(Vue.$apiConfig.editRegistrationPost, tempRegistration)
          .then((response) => {
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.registrationUpdated'),
              errors: []
            })
            this.load = false
            this.$v.$reset()
          }, (error) => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'register.registrationLimitExceeded')
            this.load = false
          })
      },
      editRegistrationShown () {
        if (this.register && this.register.companyNumber) { return }
        this.load = true
        this.$http.get(Vue.$apiConfig.registrationInformationGet)
          .then(response => {
            this.logConsole(response)
            // get body data
            let registration = response.data.payload
            this.register = registration
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      validateUserInformation () {
        this.logConsole(this.user)
        this.$v.$touch()
        let userValidationErrors = this.getValidationErrors('user')
        if (userValidationErrors && userValidationErrors.length > 0) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('user')
          })
          return
        }
        this.editUser()
      },
      editUser () {
        this.load = true
        this.$http.post(Vue.$apiConfig.updateUserInformationPost, this.user)
          .then(response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.userUpdated'),
              errors: []
            })
            this.load = false
            this.$v.$reset()
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      saveRegional () {
        this.$store.dispatch('regional', {
          language: this.personal.language.value,
          dateFormat: this.personal.dateFormat.value,
          // dateLocale: this.personal.dateLocale.value,
          decimalFormat: this.personal.decimalFormat.value,
          csvDelimmeter: this.personal.csvDelimmeter.value
        }).then(() => {
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('userSettings.settingsSavedSuccess'),
            errors: []
          })
        }).catch(error => {
          this.logConsole(error)
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('userSettings.settingsSavedFail'),
            errors: []
          })
        })
      }
    },
    validations: {
      register: {
        name: {
          required
        },
        address: {
          required
        },
        phoneNumber: {
          required
        },
        email: {
          required, email
        },
        adminName: {
          required
        },
        adminIdentityNumber: {
          required
        },
        adminEmail: {
          required, email
        },
        adminPhoneNumber: {
          required
        }
      },
      user: {
        login: {
          required
        },
        name: {
          required
        },
        email: {
          required
        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';
  @import '~@/assets/scss/main.scss';

  .user-info-label {
    font-weight: 600;
  }

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

</style>




// WEBPACK FOOTER //
// UserProfile.vue?216f5f55